import React, { Suspense, useContext } from 'react';

import PlaylistKPIs from 'components/data-containers/KPIs/Playlist/PlaylistKPIs';
import { EntityContext } from 'context/entityContext';
import PlaylistTable from 'components/data-containers/PlaylistTable';
import PriorityPlaylistLoader from 'components/data-containers/PlaylistPriorityActivity/SkeletonLoader';

const PriorityPlaylistActivity = React.lazy(
  () => import('components/data-containers/PlaylistPriorityActivity')
);

const Playlist: React.FC = () => {
  const { compareMode } = useContext(EntityContext);

  return (
    <div>
      <PlaylistKPIs />

      {!compareMode && (
        <>
          <Suspense
            fallback={
              <PriorityPlaylistLoader title="Priority Playlist Activity" />
            }
          >
            <PriorityPlaylistActivity />
          </Suspense>

          <PlaylistTable />
        </>
      )}
    </div>
  );
};

export default Playlist;
